import axios from '../../../axios'

export default {
  getRailObjects () {
    return axios.get('axlecounter/railobject').then(response => response.data)
  },
  getMeasurements (filter) {
    return axios.get('axlecounter/measurement' + filter).then(response => response.data)
  },
  getRailObjectZPR (filter) {
    return axios.get('axlecounter/railobjectzpr' + filter).then(response => response.data)
  },
  getRailObjectZPRStatus (filter) {
    return axios.get('axlecounter/railobjectzprstatus' + filter).then(response => response.data)
  },
  getSubCommands () {
    return axios.get('axlecounter/subcommand').then(response => response.data)
  },
  getLogBook (filter) {
    return axios.get('axlecounter/logbook' + filter).then(response => response.data)
  },
  addLogBook (data) {
    return axios.post('axlecounter/logbook', data)
  },
  getAlarmSetting (filter) {
    return axios.get('axlecounter/alarmsetting' + filter).then(response => response.data)
  },
  updateAlarmSetting (data) {
    return axios.patch('axlecounter/alarmsetting', data)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/axlecounter/AxleCounterApi.js